"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatValue = exports["default"] = void 0;
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _numberFormatter = require("./numberFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports["default"] = function _default(position, symbol) {
  if (!position) {
    var formatattedPosition = {
      ProductSymbol: symbol,
      Hold: formatValue(0, symbol),
      PendingDeposits: formatValue(0, symbol),
      Amount: formatValue(0, symbol),
      rawAmount: 0,
      AvailableBalance: formatValue(0, symbol),
      rawBalance: 0
    };
    return formatattedPosition;
  }
  var formattedPosition = _objectSpread({}, position);
  formattedPosition.Hold = formatValue(position.Hold, symbol);
  formattedPosition.PendingDeposits = formatValue(position.PendingDeposits, symbol);
  formattedPosition.Amount = formatValue(position.Amount, symbol);
  formattedPosition.rawAmount = position.Amount;
  formattedPosition.AvailableBalance = formattedPosition.Amount;
  formattedPosition.rawBalance = position.Amount;
  if (position.Amount !== 0 && position.Hold !== 0) {
    var availableBalance = new _bignumber["default"](position.Amount).minus(position.Hold);
    formattedPosition.rawBalance = availableBalance.toNumber();
    formattedPosition.AvailableBalance = (0, _numberFormatter.formatNumberToLocale)(availableBalance, symbol);
  }
  return formattedPosition;
};
var formatValue = exports.formatValue = function formatValue(value, symbol) {
  if (value === 0) {
    return (0, _numberFormatter.replaceZeroWithDash)(value);
  }
  return (0, _numberFormatter.formatNumberToLocale)(value, symbol);
};